const state = {
  searchParams: JSON.parse(sessionStorage.getItem('searchParams')) || {
    route: null,
    mainaData: {},
    extraData: {},
    isExpanded: null,
  },
}
const getters = {
  searchParams: state => state.searchParams,
}
const actions = {
  searchParams({ commit }, payload) {
    commit('searchParams', payload)
    sessionStorage.setItem('searchParams', JSON.stringify(payload))
  },
}
const mutations = {
  searchParams(state, data) {
    state.searchParams = data
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
